if (!customElements.get('card-slider')) {
    class CardSlider extends HTMLElement {
        constructor() {
            super()

            this._pointerStartX = 0;
            this._pointerStartY = 0;
            this._isPointerDown = false;
            this._didDrag = false;
            this._dragThreshold = 8;
            this._suppressClickUntil = 0;
            this._pressedLink = null;

            this._onPointerDown = this.handlePointerDown.bind(this);
            this._onPointerMove = this.handlePointerMove.bind(this);
            this._onPointerUp = this.handlePointerUp.bind(this);
            this._onClickCapture = this.handleClickCapture.bind(this);

            this.init()
        }

        init() {
            if (!this._pointerGuardsBound) {
                this._pointerGuardsBound = true;
                this.addEventListener('pointerdown', this._onPointerDown, true);
                this.addEventListener('pointermove', this._onPointerMove, { passive: true });
                this.addEventListener('pointerup', this._onPointerUp, true);
                this.addEventListener('pointercancel', this._onPointerUp, true);
                this.addEventListener('click', this._onClickCapture, true);
            }

            if (this.dataset.overflowScroll === 'true' && !this._overflowWatch) {
                this._overflowWatch = window.matchMedia('(max-width: 749px)');
                this._onOverflowWatch = () => this.mountCarousel();
                this._overflowWatch.addEventListener('change', this._onOverflowWatch);
            }

            this.mountCarousel();
        }

        mountCarousel() {
            const overflowOnSmall = this.dataset.overflowScroll === 'true' && window.matchMedia('(max-width: 749px)').matches;
            if (overflowOnSmall) {
                if (this.carousel && typeof this.carousel.destroy === 'function') {
                    this.carousel.destroy();
                    this.carousel = null;
                }
                return;
            }

            if (this.carousel) return;

            const infinite = this.dataset.infinite !== 'false';
            const slidesPerPageAttr = this.dataset.slidesPerPage;
            const slidesPerPage = slidesPerPageAttr === 'auto' ? 'auto' : (parseInt(slidesPerPageAttr, 10) || 1);
            const options = {
                infinite,
                center: false,
                slidesPerPage,
                transition: 'slide',
                Navigation: {
                    prevTpl: '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 11L1.5 6L6.5 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                    nextTpl: '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L6.5 6L1.5 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                },
            };

            if (this.dataset.fill === 'false') options.fill = false;
            if (this.dataset.dragFree === 'true') options.dragFree = true;
            if (this.dataset.dots === 'false') options.Dots = false;
            if (this.dataset.nav === 'false') options.Navigation = false;

            this.carousel = new Carousel(this, options);
        }

        disconnectedCallback() {
            this.removeEventListener('pointerdown', this._onPointerDown);
            this.removeEventListener('pointermove', this._onPointerMove);
            this.removeEventListener('pointerup', this._onPointerUp);
            this.removeEventListener('pointercancel', this._onPointerUp);
            this.removeEventListener('click', this._onClickCapture, true);
            if (this._overflowWatch && this._onOverflowWatch) {
                this._overflowWatch.removeEventListener('change', this._onOverflowWatch);
            }
            if (this.carousel && typeof this.carousel.destroy === 'function') {
                this.carousel.destroy();
            }
        }

        isIgnoredControl(event) {
            return event.target instanceof Element && Boolean(
                event.target.closest('button, [data-action="add-to-cart"]')
            );
        }

        handlePointerDown(event) {
            this._isPointerDown = true;
            this._didDrag = false;
            this._pointerStartX = event.clientX;
            this._pointerStartY = event.clientY;
            this._pressedLink = this.isIgnoredControl(event)
                ? null
                : (event.target instanceof Element ? event.target.closest('a[href]') : null);
        }

        handlePointerMove(event) {
            if (!this._isPointerDown || this._didDrag) return;

            const deltaX = Math.abs(event.clientX - this._pointerStartX);
            const deltaY = Math.abs(event.clientY - this._pointerStartY);

            if (deltaX > this._dragThreshold || deltaY > this._dragThreshold) {
                this._didDrag = true;
            }
        }

        handlePointerUp(event) {
            if (this._didDrag) {
                this._suppressClickUntil = performance.now() + 250;
                this._didDrag = false;
                this._pressedLink = null;
                this._isPointerDown = false;
                return;
            }

            if (this.isIgnoredControl(event)) {
                this._pressedLink = null;
                this._isPointerDown = false;
                return;
            }

            const releasedLink = event.target instanceof Element ? event.target.closest('a[href]') : null;
            const sameLink = this._pressedLink && releasedLink && this._pressedLink === releasedLink;

            if (sameLink) {
                const link = this._pressedLink;
                this._pressedLink = null;
                this._isPointerDown = false;

                if (link.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
                    return;
                }

                this._suppressClickUntil = performance.now() + 300;
                event.preventDefault();
                event.stopPropagation();
                window.location.assign(link.href);
                return;
            }

            this._pressedLink = null;
            this._isPointerDown = false;
        }

        handleClickCapture(event) {
            if (this.isIgnoredControl(event)) return;
            
            const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
            if (!link || !this.contains(link)) return;

            if (performance.now() < this._suppressClickUntil) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }

            if (event.defaultPrevented) {
                return;
            }

            if (link.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            window.location.assign(link.href);
        }
    }

    customElements.define('card-slider', CardSlider);
}

function madesaShouldDeferRangeAutoSubmit(form) {
    if (!form || form.id !== 'madesa-filter-form') return false;
    try {
        return window.innerWidth < 750;
    } catch (e) {
        return false;
    }
}

if (!customElements.get('price-range')) {
    class PriceRange extends HTMLElement {
        constructor() {
            super();
            this.rangeGap = 5;
            this.updateTimeout = null;
            this._savedPriceParamNames = null;
            this._priceParamsSuppressed = false;
            this._madesaRangeInitialized = false;
            this._onMinRangeInput = this.changeMinRange.bind(this);
            this._onMaxRangeInput = this.changeMaxRange.bind(this);
            this._onRangeChange = this.applyFilter.bind(this);
            this._onPointerDown = this.handleTrackClick.bind(this);
        }

        connectedCallback() {
            if (this._madesaRangeInitialized) return;
            this._madesaRangeInitialized = true;

            this.minRange = this.querySelector(".madesa-range-min") || this.querySelector("#range-min");
            this.maxRange = this.querySelector(".madesa-range-max") || this.querySelector("#range-max");
            this.minPrice = this.querySelector(".madesa-min-price") || this.querySelector("#min-price");
            this.maxPrice = this.querySelector(".madesa-max-price") || this.querySelector("#max-price");
            this.minPriceDisplay = this.querySelector(".madesa-range-min-display") || this.querySelector("#min-price-display");
            this.maxPriceDisplay = this.querySelector(".madesa-range-max-display") || this.querySelector("#max-price-display");
            this.manualMin = this.querySelector('.madesa-range-manual-min');
            this.manualMax = this.querySelector('.madesa-range-manual-max');
            this.rangeBar = this.querySelector(".range-bar");
            this.sliderTrack = this.querySelector(".slider");
            this.currencySymbol = this.dataset.currencySymbol || 'R$';

            this.listener();
        }

        disconnectedCallback() {
            this._madesaRangeInitialized = false;
            if (this.updateTimeout) {
                clearTimeout(this.updateTimeout);
                this.updateTimeout = null;
            }
            this.minRange?.removeEventListener("input", this._onMinRangeInput);
            this.maxRange?.removeEventListener("input", this._onMaxRangeInput);
            this.minRange?.removeEventListener("change", this._onRangeChange);
            this.maxRange?.removeEventListener("change", this._onRangeChange);
            this.sliderTrack?.removeEventListener('pointerdown', this._onPointerDown);
            this.removeEventListener('pointerdown', this._onPointerDown);
        }

        suppressFullRangePriceParams() {
            if (!this.minRange || !this.maxRange) return;
            if (!this._savedPriceParamNames) {
                this._savedPriceParamNames = {
                    min: this.minRange.getAttribute('name') || '',
                    max: this.maxRange.getAttribute('name') || '',
                };
            }
            const lo = parseFloat(String(this.minRange.min));
            const hi = parseFloat(String(this.maxRange.max));
            const minV = parseFloat(String(this.minRange.value));
            const maxV = parseFloat(String(this.maxRange.value));
            if (!Number.isFinite(lo) || !Number.isFinite(hi) || hi <= lo) return;

            const span = hi - lo;
            const eps = Math.max(0.01, span * 1e-9);
            const isFull = minV <= lo + eps && maxV >= hi - eps;

            if (isFull) {
                this.minRange.removeAttribute('name');
                this.maxRange.removeAttribute('name');
                this._priceParamsSuppressed = true;
            } else {
                if (this._savedPriceParamNames.min) {
                    this.minRange.setAttribute('name', this._savedPriceParamNames.min);
                }
                if (this._savedPriceParamNames.max) {
                    this.maxRange.setAttribute('name', this._savedPriceParamNames.max);
                }
                this._priceParamsSuppressed = false;
            }
        }

        restorePriceRangeInputNames() {
            if (!this._priceParamsSuppressed || !this.minRange || !this.maxRange) return;
            if (this._savedPriceParamNames) {
                if (this._savedPriceParamNames.min) {
                    this.minRange.setAttribute('name', this._savedPriceParamNames.min);
                }
                if (this._savedPriceParamNames.max) {
                    this.maxRange.setAttribute('name', this._savedPriceParamNames.max);
                }
            }
            this._priceParamsSuppressed = false;
        }

        applyManualValuesBeforeSubmit() {
            if (!this.manualMin || !this.manualMax || !this.minRange || !this.maxRange) return;
            let vMin = parseFloat(String(this.manualMin.value).trim().replace(',', '.'));
            let vMax = parseFloat(String(this.manualMax.value).trim().replace(',', '.'));
            if (Number.isNaN(vMin)) vMin = parseFloat(this.minRange.value);
            if (Number.isNaN(vMax)) vMax = parseFloat(this.maxRange.value);
            const lo = parseFloat(this.minRange.min);
            const hi = parseFloat(this.maxRange.max);
            let minV = Math.min(Math.max(vMin, lo), hi);
            let maxV = Math.min(Math.max(vMax, lo), hi);
            if (minV > maxV) {
                const t = minV;
                minV = maxV;
                maxV = t;
            }
            if (maxV - minV <= this.rangeGap) {
                maxV = Math.min(hi, minV + this.rangeGap);
                if (maxV - minV <= this.rangeGap) {
                    minV = Math.max(lo, maxV - this.rangeGap);
                }
            }
            this.minRange.value = String(minV);
            this.maxRange.value = String(maxV);
            this.manualMin.value = minV.toFixed(2);
            this.manualMax.value = maxV.toFixed(2);
            this.minRange.dispatchEvent(new Event('input', { bubbles: true }));
            this.maxRange.dispatchEvent(new Event('input', { bubbles: true }));
            this.updateRangeBarTrack();
        }

        listener() {
            this.minRange?.addEventListener("input", this._onMinRangeInput);
            this.maxRange?.addEventListener("input", this._onMaxRangeInput);
            this.minRange?.addEventListener("change", this._onRangeChange);
            this.maxRange?.addEventListener("change", this._onRangeChange);

            this.sliderTrack?.addEventListener('pointerdown', this._onPointerDown);

            const event = new Event('input');
            this.minRange?.dispatchEvent(event);
            this.maxRange?.dispatchEvent(event);
        }

        handleTrackClick(event) {
            if (!this.minRange || !this.maxRange) return;
            if (!(event.target instanceof Element)) return;
            if (event.target.closest('input[type="range"]')) return;
            if (!event.target.closest('.slider')) return;

            const rect = (this.sliderTrack || this.minRange).getBoundingClientRect();
            if (rect.width <= 0) return;

            const clickX = event.clientX - rect.left;
            const percentage = Math.max(0, Math.min(1, clickX / rect.width));
            
            const min = parseFloat(this.minRange.min || 0);
            const max = parseFloat(this.maxRange.max || 100);
            const clickedValue = min + percentage * (max - min);

            const currentMin = parseFloat(this.minRange.value);
            const currentMax = parseFloat(this.maxRange.value);

            const targetInput = Math.abs(clickedValue - currentMin) <= Math.abs(clickedValue - currentMax) ? this.minRange : this.maxRange;
            
            targetInput.value = clickedValue;
            targetInput.dispatchEvent(new Event('input', { bubbles: true }));
            targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        formatCurrency(value) {
            return new Intl.NumberFormat('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        }

        changeMinRange(event) {
            if (!this.minRange || !this.maxRange) return;

            if (parseFloat(this.maxRange.value) - parseFloat(this.minRange.value) <= this.rangeGap) {
                this.minRange.value = parseFloat(this.maxRange.value) - this.rangeGap;
            }

            const minValue = parseFloat(this.minRange.value);
            if (this.minPrice) this.minPrice.value = minValue.toFixed(2);
            if (this.minPriceDisplay) {
                this.minPriceDisplay.textContent = `${this.currencySymbol} ${this.formatCurrency(minValue)}`;
            }
            if (this.manualMin && document.activeElement !== this.manualMin) {
                this.manualMin.value = minValue.toFixed(2);
            }

            this.updateRangeBarTrack();
        }

        changeMaxRange(event) {
            if (!this.minRange || !this.maxRange) return;

            if (parseFloat(this.maxRange.value) - parseFloat(this.minRange.value) <= this.rangeGap) {
                this.maxRange.value = parseFloat(this.minRange.value) + this.rangeGap;
            }

            const maxValue = parseFloat(this.maxRange.value);
            if (this.maxPrice) this.maxPrice.value = maxValue.toFixed(2);
            if (this.maxPriceDisplay) {
                this.maxPriceDisplay.textContent = `${this.currencySymbol} ${this.formatCurrency(maxValue)}`;
            }
            if (this.manualMax && document.activeElement !== this.manualMax) {
                this.manualMax.value = maxValue.toFixed(2);
            }

            this.updateRangeBarTrack();
        }

        updateRangeBarTrack() {
            if (!this.rangeBar || !this.minRange || !this.maxRange) return;
            const lo = parseFloat(this.minRange.min);
            const hi = parseFloat(this.maxRange.max);
            const span = hi - lo;
            if (span <= 0) return;
            const minVal = parseFloat(this.minRange.value);
            const maxVal = parseFloat(this.maxRange.value);
            const leftPct = ((minVal - lo) / span) * 100;
            const rightPct = ((maxVal - lo) / span) * 100;
            this.rangeBar.style.left = `${leftPct}%`;
            this.rangeBar.style.right = `${100 - rightPct}%`;
        }

        resetFilterToDefault() {
            if (this.updateTimeout) {
                clearTimeout(this.updateTimeout);
                this.updateTimeout = null;
            }
            if (!this.minRange || !this.maxRange) return;
            this.restorePriceRangeInputNames();
            this.minRange.value = String(this.minRange.min);
            this.maxRange.value = String(this.maxRange.max);
            this.minRange.dispatchEvent(new Event('input', { bubbles: true }));
            this.maxRange.dispatchEvent(new Event('input', { bubbles: true }));
            const lo = parseFloat(this.minRange.min);
            const hi = parseFloat(this.maxRange.max);
            if (this.manualMin && Number.isFinite(lo)) {
                this.manualMin.value = lo.toFixed(2);
            }
            if (this.manualMax && Number.isFinite(hi)) {
                this.manualMax.value = hi.toFixed(2);
            }
        }

        applyFilter() {
            if (this.updateTimeout) {
                clearTimeout(this.updateTimeout);
            }

            this.updateTimeout = setTimeout(() => {
                const form = this.closest('form');
                if (madesaShouldDeferRangeAutoSubmit(form)) {
                    return;
                }
                if (form) {
                    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }
            }, 300);
        }
    }

    customElements.define("price-range", PriceRange);
}

if (!customElements.get('list-range')) {
    class ListRange extends HTMLElement {
        static numericFromLabel(label) {
            if (label == null || label === '') return NaN;
            const s = String(label).replace(/[^\d.,\-]/g, '');
            if (!s) return NaN;
            const normalized = s.includes(',') ? s.replace(/\./g, '').replace(',', '.') : s;
            const n = parseFloat(normalized);
            return Number.isFinite(n) ? n : NaN;
        }

        constructor() {
            super();
            this.updateTimeout = null;
            this._madesaRangeInitialized = false;
            this._userDirty = false;
            this._onMinRangeInput = this.changeMinRange.bind(this);
            this._onMaxRangeInput = this.changeMaxRange.bind(this);
            this._onRangeChange = this.applyFilter.bind(this);
            this._onPointerDown = this.handleTrackClick.bind(this);
            this._onManualInput = this.markDirty.bind(this);
        }

        connectedCallback() {
            if (this._madesaRangeInitialized) return;
            this._madesaRangeInitialized = true;
            this._userDirty = false;

            this.minRange = this.querySelector(".madesa-range-min") || this.querySelector("#range-min");
            this.maxRange = this.querySelector(".madesa-range-max") || this.querySelector("#range-max");
            this.minDisplay = this.querySelector(".madesa-range-min-display") || this.querySelector("#min-price-display");
            this.maxDisplay = this.querySelector(".madesa-range-max-display") || this.querySelector("#max-price-display");
            this.manualMin = this.querySelector('.madesa-range-manual-min');
            this.manualMax = this.querySelector('.madesa-range-manual-max');
            this.rangeBar = this.querySelector(".range-bar");
            this.sliderTrack = this.querySelector(".slider");
            this.labelSuffix = this.dataset.labelSuffix || '';

            try {
                this.values = JSON.parse(this.dataset.values || "[]");
            } catch (e) {
                this.values = [];
            }

            this.inputs = Array.from(this.querySelectorAll("[data-list-range-value]"));

            this.init();
        }

        disconnectedCallback() {
            this._madesaRangeInitialized = false;
            this._userDirty = false;
            if (this.updateTimeout) {
                clearTimeout(this.updateTimeout);
                this.updateTimeout = null;
            }
            this.minRange?.removeEventListener("input", this._onMinRangeInput);
            this.maxRange?.removeEventListener("input", this._onMaxRangeInput);
            this.minRange?.removeEventListener("change", this._onRangeChange);
            this.maxRange?.removeEventListener("change", this._onRangeChange);
            this.sliderTrack?.removeEventListener('pointerdown', this._onPointerDown);
            this.removeEventListener('pointerdown', this._onPointerDown);
            this.manualMin?.removeEventListener('input', this._onManualInput);
            this.manualMax?.removeEventListener('input', this._onManualInput);
            this.manualMin?.removeEventListener('change', this._onManualInput);
            this.manualMax?.removeEventListener('change', this._onManualInput);
        }

        markDirty() {
            this._userDirty = true;
        }

        findNearestIndex(target) {
            if (!Number.isFinite(target)) return 0;
            let best = 0;
            let bestDist = Infinity;
            this.values.forEach((value, index) => {
                const n = ListRange.numericFromLabel(value.label);
                if (!Number.isFinite(n)) return;
                const d = Math.abs(n - target);
                if (d < bestDist) {
                    bestDist = d;
                    best = index;
                }
            });
            return best;
        }

        applyManualValuesBeforeSubmit() {
            if (!this._userDirty) return;
            if (!this.manualMin || !this.manualMax || !this.minRange || !this.maxRange || this.values.length === 0) {
                return;
            }
            let minT = parseFloat(String(this.manualMin.value).trim().replace(',', '.'));
            let maxT = parseFloat(String(this.manualMax.value).trim().replace(',', '.'));
            if (Number.isNaN(minT)) {
                minT = ListRange.numericFromLabel(this.values[parseInt(this.minRange.value, 10)]?.label);
            }
            if (Number.isNaN(maxT)) {
                maxT = ListRange.numericFromLabel(this.values[parseInt(this.maxRange.value, 10)]?.label);
            }
            if (!Number.isFinite(minT)) minT = 0;
            if (!Number.isFinite(maxT)) maxT = minT;
            let minI = this.findNearestIndex(minT);
            let maxI = this.findNearestIndex(maxT);
            if (minI > maxI) {
                const t = minI;
                minI = maxI;
                maxI = t;
            }
            this.minRange.value = String(minI);
            this.maxRange.value = String(maxI);
            this.updateDisplays();
            this.syncCheckboxesFromSliders();
        }

        syncCheckboxesFromSliders() {
            const minIndex = parseInt(this.minRange.value, 10);
            const maxIndex = parseInt(this.maxRange.value, 10);
            const lastIndex = this.values.length > 0 ? this.values.length - 1 : 0;
            const isFullRange =
                this.values.length > 0 && minIndex === 0 && maxIndex === lastIndex;

            this.inputs.forEach((input) => {
                if (isFullRange) {
                    input.checked = false;
                } else {
                    const index = parseInt(input.dataset.listRangeIndex, 10);
                    input.checked = index >= minIndex && index <= maxIndex;
                }
            });
        }

        init() {
            if (!this.minRange || !this.maxRange || this.values.length === 0) return;

            const activeIndices = this.values
                .map((value, index) => (value.active ? index : null))
                .filter((index) => index !== null);

            const minIndex = activeIndices.length ? Math.min(...activeIndices) : 0;
            const maxIndex = activeIndices.length ? Math.max(...activeIndices) : this.values.length - 1;

            this.minRange.value = minIndex;
            this.maxRange.value = maxIndex;

            this.minRange.addEventListener("input", this._onMinRangeInput);
            this.maxRange.addEventListener("input", this._onMaxRangeInput);
            this.minRange.addEventListener("change", this._onRangeChange);
            this.maxRange.addEventListener("change", this._onRangeChange);
            this.manualMin?.addEventListener('input', this._onManualInput);
            this.manualMax?.addEventListener('input', this._onManualInput);
            this.manualMin?.addEventListener('change', this._onManualInput);
            this.manualMax?.addEventListener('change', this._onManualInput);

            this.sliderTrack?.addEventListener('pointerdown', this._onPointerDown);

            this.updateDisplays();
        }

        handleTrackClick(event) {
            if (!this.minRange || !this.maxRange) return;
            if (!(event.target instanceof Element)) return;
            if (event.target.closest('input[type="range"]')) return;
            if (!event.target.closest('.slider')) return;

            const rect = (this.sliderTrack || this.minRange).getBoundingClientRect();
            if (rect.width <= 0) return;

            const clickX = event.clientX - rect.left;
            const percentage = Math.max(0, Math.min(1, clickX / rect.width));
            
            const min = parseFloat(this.minRange.min || 0);
            const max = parseFloat(this.maxRange.max || 100);
            const clickedValue = Math.round(min + percentage * (max - min));

            const currentMin = parseFloat(this.minRange.value);
            const currentMax = parseFloat(this.maxRange.value);

            const targetInput = Math.abs(clickedValue - currentMin) <= Math.abs(clickedValue - currentMax) ? this.minRange : this.maxRange;
            
            this.markDirty();
            targetInput.value = clickedValue;
            targetInput.dispatchEvent(new Event('input', { bubbles: true }));
            targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        changeMinRange() {
            this.markDirty();
            if (parseInt(this.minRange.value, 10) > parseInt(this.maxRange.value, 10)) {
                this.minRange.value = this.maxRange.value;
            }

            this.updateDisplays();
        }

        changeMaxRange() {
            this.markDirty();
            if (parseInt(this.maxRange.value, 10) < parseInt(this.minRange.value, 10)) {
                this.maxRange.value = this.minRange.value;
            }

            this.updateDisplays();
        }

        updateDisplays() {
            const minIndex = parseInt(this.minRange.value, 10);
            const maxIndex = parseInt(this.maxRange.value, 10);

            if (this.minDisplay) {
                const minLabel = this.values[minIndex]?.label || '';
                this.minDisplay.textContent = this.labelSuffix ? `${minLabel} ${this.labelSuffix}` : minLabel;
            }

            if (this.maxDisplay) {
                const maxLabel = this.values[maxIndex]?.label || '';
                this.maxDisplay.textContent = this.labelSuffix ? `${maxLabel} ${this.labelSuffix}` : maxLabel;
            }

            const minN = ListRange.numericFromLabel(this.values[minIndex]?.label);
            const maxN = ListRange.numericFromLabel(this.values[maxIndex]?.label);
            if (this.manualMin && document.activeElement !== this.manualMin) {
                this.manualMin.value = Number.isFinite(minN) ? String(minN) : '';
            }
            if (this.manualMax && document.activeElement !== this.manualMax) {
                this.manualMax.value = Number.isFinite(maxN) ? String(maxN) : '';
            }

            const minPercent = ((minIndex - this.minRange.min) / (this.maxRange.max - this.minRange.min)) * 100;
            const maxPercent = ((maxIndex - this.minRange.min) / (this.maxRange.max - this.minRange.min)) * 100;

            if (this.rangeBar) {
                this.rangeBar.style.left = minPercent + "%";
                this.rangeBar.style.right = 100 - maxPercent + "%";
            }
        }

        resetFilterToDefault() {
            if (this.updateTimeout) {
                clearTimeout(this.updateTimeout);
                this.updateTimeout = null;
            }
            if (!this.minRange || !this.maxRange || this.values.length === 0) return;
            const last = this.values.length - 1;
            const loAttr = this.minRange.getAttribute('min');
            const hiAttr = this.maxRange.getAttribute('max');
            const lo = loAttr != null && loAttr !== '' ? loAttr : '0';
            const hi = hiAttr != null && hiAttr !== '' ? hiAttr : String(last);
            this.minRange.value = String(lo);
            this.maxRange.value = String(hi);
            this._userDirty = false;
            this.syncCheckboxesFromSliders();
            this.updateDisplays();
        }

        applyFilter() {
            if (this.updateTimeout) {
                clearTimeout(this.updateTimeout);
            }

            this.updateTimeout = setTimeout(() => {
                this.syncCheckboxesFromSliders();

                const form = this.closest('form');
                if (madesaShouldDeferRangeAutoSubmit(form)) {
                    return;
                }
                if (form) {
                    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }
            }, 300);
        }
    }

    customElements.define("list-range", ListRange);
}

if (!customElements.get('categories-scrollbar')) {
    class CategoriesScrollbar extends HTMLElement {
        constructor() {
            super();

            this.handleScroll = this.handleScroll.bind(this);
            this.handleResize = this.handleResize.bind(this);
        }

        connectedCallback() {
            this.carousel = this.querySelector(".categories-showcase__carousel");
            this.scrollbar = this.querySelector(".categories-showcase__scrollbar");

            if (!this.carousel || !this.scrollbar) {
                return;
            }

            this.thumb = this.scrollbar.querySelector(".categories-showcase__scrollbar-thumb");

            if (!this.thumb) {
                return;
            }

            this.updateThumb();

            this.carousel.addEventListener("scroll", this.handleScroll);
            window.addEventListener("resize", this.handleResize);
        }

        disconnectedCallback() {
            if (this.carousel) {
                this.carousel.removeEventListener("scroll", this.handleScroll);
            }

            window.removeEventListener("resize", this.handleResize);
        }

        handleScroll() {
            this.updateThumb();
        }

        handleResize() {
            this.updateThumb();
        }

        updateThumb() {
            var carousel = this.carousel;
            var scrollbar = this.scrollbar;
            var thumb = this.thumb;

            if (!carousel || !scrollbar || !thumb) {
                return;
            }

            var scrollWidth = carousel.scrollWidth;
            var clientWidth = carousel.clientWidth;
            var scrollLeft = carousel.scrollLeft;

            if (scrollWidth <= clientWidth) {
                scrollbar.style.visibility = "hidden";
                return;
            }

            scrollbar.style.visibility = "visible";

            var visibleRatio = clientWidth / scrollWidth;
            var thumbWidth = visibleRatio * 100;

            if (thumbWidth < 10) {
                thumbWidth = 10;
            }

            if (thumbWidth > 25) {
                thumbWidth = 25;
            }

            var maxTranslate = 100 - thumbWidth;
            var scrollRatio = scrollLeft / (scrollWidth - clientWidth);
            var translatePercent = maxTranslate * scrollRatio;

            thumb.style.width = thumbWidth + "%";
            thumb.style.left = translatePercent + "%";
        }
    }

    customElements.define("categories-scrollbar", CategoriesScrollbar);
}

// PÁGINA DE ENCANTAMENTO
if (!customElements.get('madesa-depoimentos')) {
    class MadesaDepoimentos extends HTMLElement {
        constructor() {
            super();
            this._teardowns = [];
            
            // Modal properties
            this.modal = null;
            this.modalImage = null;
            this.modalImageWrapper = null;
            this.modalLoader = null;
            this.modalClose = null;
            this.modalOverlay = null;
            this.modalZoomControls = null;
            this.modalZoomIn = null;
            this.modalZoomOut = null;
            this.modalZoomReset = null;
            this.modalNavPrev = null;
            this.modalNavNext = null;
            
            this.currentZoom = 1;
            this.minZoom = 1;
            this.maxZoom = 3;
            this.zoomStep = 0.5;
            this.currentImageIndex = 0;
            this.currentCarouselImages = [];
            this.isDragging = false;
            this.dragStarted = false;
            this.mouseDown = false;
            this.touchDown = false;
            this.startX = 0;
            this.startY = 0;
            this.scrollLeft = 0;
            this.scrollTop = 0;
        }

        connectedCallback() {
            this._bindTextShells();
            this._setupModal();
            this._setupMasonryColumns();
        }

        disconnectedCallback() {
            this._unbindTextShells();
            this._destroyModal();
        }

        /**
         * Masonry em mobile usava column-count, que rebalanceia colunas quando a altura dos cards muda (ex.: Ler +).
         * Duas colunas flex com distribuição ímpar/par mantém cada card na sua coluna.
         */
        _flattenMasonryGrid(grid) {
            if (!grid || grid.dataset.madesaMasonrySplit !== '1') return;
            const cols = grid.querySelectorAll(':scope > .madesa-depoimentos__masonry-col');
            if (cols.length !== 2) {
                grid.classList.remove('madesa-depoimentos__grid--masonry-split');
                delete grid.dataset.madesaMasonrySplit;
                return;
            }
            const L = Array.from(cols[0].children);
            const R = Array.from(cols[1].children);
            const maxLen = Math.max(L.length, R.length);
            for (let i = 0; i < maxLen; i++) {
                if (L[i]) grid.appendChild(L[i]);
                if (R[i]) grid.appendChild(R[i]);
            }
            cols[0].remove();
            cols[1].remove();
            grid.classList.remove('madesa-depoimentos__grid--masonry-split');
            delete grid.dataset.madesaMasonrySplit;
        }

        _splitMasonryForMobile(grid) {
            if (!grid || grid.dataset.madesaMasonrySplit === '1') return;
            const cards = Array.from(grid.children).filter(function (el) {
                return el.classList && el.classList.contains('madesa-depoimentos__card');
            });
            if (cards.length === 0) return;
            var left = document.createElement('div');
            left.className = 'madesa-depoimentos__masonry-col';
            var right = document.createElement('div');
            right.className = 'madesa-depoimentos__masonry-col';
            cards.forEach(function (card, i) {
                (i % 2 === 0 ? left : right).appendChild(card);
            });
            grid.appendChild(left);
            grid.appendChild(right);
            grid.classList.add('madesa-depoimentos__grid--masonry-split');
            grid.dataset.madesaMasonrySplit = '1';
        }

        _syncMasonryLayout() {
            if (this.dataset.mobileLayout !== 'masonry') return;
            var grid = this.querySelector('.madesa-depoimentos__grid');
            if (!grid) return;
            var mobile = window.matchMedia('(max-width: 719.98px)').matches;
            if (mobile) {
                this._splitMasonryForMobile(grid);
            } else {
                this._flattenMasonryGrid(grid);
            }
        }

        _setupMasonryColumns() {
            var self = this;
            var grid = this.querySelector('.madesa-depoimentos__grid');
            if (!grid) return;

            if (this.dataset.mobileLayout !== 'masonry') {
                this._flattenMasonryGrid(grid);
                return;
            }

            this._syncMasonryLayoutBound =
                this._syncMasonryLayoutBound || this._syncMasonryLayout.bind(this);
            this._masonryMq = window.matchMedia('(max-width: 719.98px)');
            this._masonryMq.addEventListener('change', this._syncMasonryLayoutBound);

            this._teardowns.push(function () {
                if (self._masonryMq && self._syncMasonryLayoutBound) {
                    self._masonryMq.removeEventListener('change', self._syncMasonryLayoutBound);
                }
                var g = self.querySelector('.madesa-depoimentos__grid');
                if (g) self._flattenMasonryGrid(g);
            });

            requestAnimationFrame(function () {
                self._syncMasonryLayout();
            });
        }

        _setupModal() {
            this.enableZoom = this.dataset.enableZoom === 'true';
            
            if (!this.enableZoom) {
                return;
            }
            
            const sectionId = this.querySelector('[id^="madesa-depoimentos-modal-"]')?.id;
            if (!sectionId) return;
            
            this.modal = document.getElementById(sectionId);
            if (!this.modal) return;
            
            this.modalImage = this.modal.querySelector('.madesa-depoimentos__modal-image');
            this.modalImageWrapper = this.modal.querySelector('.madesa-depoimentos__modal-image-wrapper');
            this.modalLoader = this.modal.querySelector('.madesa-depoimentos__modal-loader');
            this.modalClose = this.modal.querySelector('.madesa-depoimentos__modal-close');
            this.modalOverlay = this.modal.querySelector('.madesa-depoimentos__modal-overlay');
            this.modalZoomControls = this.modal.querySelector('.madesa-depoimentos__modal-zoom-controls');
            this.modalZoomIn = this.modal.querySelector('.madesa-depoimentos__modal-zoom-in');
            this.modalZoomOut = this.modal.querySelector('.madesa-depoimentos__modal-zoom-out');
            this.modalZoomReset = this.modal.querySelector('.madesa-depoimentos__modal-zoom-reset');
            this.modalNavPrev = this.modal.querySelector('.madesa-depoimentos__modal-nav-prev');
            this.modalNavNext = this.modal.querySelector('.madesa-depoimentos__modal-nav-next');
            
            // Event listeners
            const handleImageClick = (e) => {
                const img = e.target.closest('.madesa-depoimentos__img--zoomable');
                if (img) this._openModal(img);
            };
            this.addEventListener('click', handleImageClick);
            this._teardowns.push(() => this.removeEventListener('click', handleImageClick));
            
            if (this.modalClose) {
                const closeHandler = () => this._closeModal();
                this.modalClose.addEventListener('click', closeHandler);
                this._teardowns.push(() => this.modalClose.removeEventListener('click', closeHandler));
            }
            
            if (this.modalOverlay) {
                const overlayHandler = () => this._closeModal();
                this.modalOverlay.addEventListener('click', overlayHandler);
                this._teardowns.push(() => this.modalOverlay.removeEventListener('click', overlayHandler));
            }
            
            if (this.modalZoomIn) {
                const zoomInHandler = () => this._zoomIn();
                this.modalZoomIn.addEventListener('click', zoomInHandler);
                this._teardowns.push(() => this.modalZoomIn.removeEventListener('click', zoomInHandler));
            }
            
            if (this.modalZoomOut) {
                const zoomOutHandler = () => this._zoomOut();
                this.modalZoomOut.addEventListener('click', zoomOutHandler);
                this._teardowns.push(() => this.modalZoomOut.removeEventListener('click', zoomOutHandler));
            }
            
            if (this.modalZoomReset) {
                const resetHandler = () => this._resetZoom();
                this.modalZoomReset.addEventListener('click', resetHandler);
                this._teardowns.push(() => this.modalZoomReset.removeEventListener('click', resetHandler));
            }
            
            if (this.modalNavPrev) {
                const prevHandler = () => this._navigatePrev();
                this.modalNavPrev.addEventListener('click', prevHandler);
                this._teardowns.push(() => this.modalNavPrev.removeEventListener('click', prevHandler));
            }
            
            if (this.modalNavNext) {
                const nextHandler = () => this._navigateNext();
                this.modalNavNext.addEventListener('click', nextHandler);
                this._teardowns.push(() => this.modalNavNext.removeEventListener('click', nextHandler));
            }
            
            if (this.modalImage) {
                const toggleHandler = (e) => {
                    if (this.dragStarted) return;
                    this._toggleZoom();
                };
                this.modalImage.addEventListener('click', toggleHandler);
                this._teardowns.push(() => this.modalImage.removeEventListener('click', toggleHandler));
            }
            
            if (this.modalImageWrapper) {
                const startDrag = this._startDrag.bind(this);
                const drag = this._drag.bind(this);
                const endDrag = this._endDrag.bind(this);
                const startDragTouch = this._startDragTouch.bind(this);
                const dragTouch = this._dragTouch.bind(this);
                const endDragTouch = this._endDragTouch.bind(this);
                
                this.modalImageWrapper.addEventListener('mousedown', startDrag);
                this.modalImageWrapper.addEventListener('mousemove', drag);
                this.modalImageWrapper.addEventListener('mouseup', endDrag);
                this.modalImageWrapper.addEventListener('mouseleave', endDrag);
                this.modalImageWrapper.addEventListener('touchstart', startDragTouch, { passive: false });
                this.modalImageWrapper.addEventListener('touchmove', dragTouch, { passive: false });
                this.modalImageWrapper.addEventListener('touchend', endDragTouch);
                this.modalImageWrapper.addEventListener('touchcancel', endDragTouch);
                
                this._teardowns.push(() => {
                    this.modalImageWrapper.removeEventListener('mousedown', startDrag);
                    this.modalImageWrapper.removeEventListener('mousemove', drag);
                    this.modalImageWrapper.removeEventListener('mouseup', endDrag);
                    this.modalImageWrapper.removeEventListener('mouseleave', endDrag);
                    this.modalImageWrapper.removeEventListener('touchstart', startDragTouch);
                    this.modalImageWrapper.removeEventListener('touchmove', dragTouch);
                    this.modalImageWrapper.removeEventListener('touchend', endDragTouch);
                    this.modalImageWrapper.removeEventListener('touchcancel', endDragTouch);
                });
            }
            
            const keyHandler = (e) => {
                if (this.modal && !this.modal.hidden) {
                    if (e.key === 'Escape') {
                        this._closeModal();
                    } else if (e.key === 'ArrowLeft') {
                        this._navigatePrev();
                    } else if (e.key === 'ArrowRight') {
                        this._navigateNext();
                    } else if (e.key === '+' || e.key === '=') {
                        this._zoomIn();
                    } else if (e.key === '-' || e.key === '_') {
                        this._zoomOut();
                    } else if (e.key === '0') {
                        this._resetZoom();
                    }
                }
            };
            document.addEventListener('keydown', keyHandler);
            this._teardowns.push(() => document.removeEventListener('keydown', keyHandler));
        }

        _destroyModal() {
            if (this.modal && !this.modal.hidden) {
                this._closeModal();
            }
        }

        _openModal(img) {
            if (!this.enableZoom || !this.modal || !this.modalImage) return;
            
            this.currentZoom = 1;
            this._resetZoom();
            
            // Get images from carousel or card
            const mediaContainer = img.closest('.madesa-depoimentos__media');
            if (mediaContainer) {
                this.currentCarouselImages = Array.from(mediaContainer.querySelectorAll('.madesa-depoimentos__img--zoomable'));
                this.currentImageIndex = this.currentCarouselImages.indexOf(img);
                
                if (this.modalNavPrev) {
                    this.modalNavPrev.hidden = this.currentCarouselImages.length <= 1;
                }
                if (this.modalNavNext) {
                    this.modalNavNext.hidden = this.currentCarouselImages.length <= 1;
                }
            }
            
            if (this.modalLoader) {
                this.modalLoader.hidden = false;
            }
            
            const imgSrc = img.src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande)\./g, '.').replace(/\?.*$/, '');
            const fullSrc = imgSrc.includes('?') ? imgSrc : `${imgSrc}?width=1500`;
            
            const hideLoader = () => {
                if (this.modalLoader) {
                    this.modalLoader.hidden = true;
                }
            };
            
            this.modalImage.onload = hideLoader;
            this.modalImage.onerror = hideLoader;
            this.modalImage.src = fullSrc;
            this.modalImage.alt = img.alt || '';
            
            if (this.modalImageWrapper) {
                this.modalImageWrapper.style.cursor = 'default';
            }
            if (this.modalImage) {
                this.modalImage.style.cursor = 'zoom-in';
            }
            
            this.modal.hidden = false;
            document.body.style.overflow = 'hidden';
        }

        _closeModal() {
            if (!this.modal) return;
            
            this.modal.hidden = true;
            document.body.style.overflow = '';
            this._resetZoom();
            this.currentCarouselImages = [];
            this.currentImageIndex = 0;
            
            if (this.modalImage) {
                this.modalImage.src = '';
                this.modalImage.alt = '';
            }
        }

        _zoomIn() {
            if (this.currentZoom >= this.maxZoom) return;
            this.currentZoom = Math.min(this.currentZoom + this.zoomStep, this.maxZoom);
            this._applyZoom();
        }

        _zoomOut() {
            if (this.currentZoom <= this.minZoom) return;
            this.currentZoom = Math.max(this.currentZoom - this.zoomStep, this.minZoom);
            this._applyZoom();
        }

        _resetZoom() {
            this.currentZoom = this.minZoom;
            this._applyZoom();
            if (this.modalImageWrapper) {
                this.modalImageWrapper.scrollLeft = 0;
                this.modalImageWrapper.scrollTop = 0;
            }
        }

        _toggleZoom() {
            if (this.currentZoom > this.minZoom) {
                this._resetZoom();
            } else {
                this.currentZoom = 2;
                this._applyZoom();
            }
        }

        _applyZoom() {
            if (!this.modalImage || !this.modalImageWrapper) return;
            
            const previousZoom = parseFloat(this.modalImage.style.transform.replace('scale(', '').replace(')', '')) || 1;
            
            this.modalImage.style.transform = `scale(${this.currentZoom})`;
            
            if (this.currentZoom > 1) {
                this.modalImage.classList.add('zoomed');
                this.modalImageWrapper.style.cursor = 'grab';
                this.modalImage.style.cursor = 'zoom-out';
                
                // Ajusta o scroll para manter o centro visível ao fazer zoom
                if (previousZoom !== this.currentZoom) {
                    const zoomRatio = this.currentZoom / previousZoom;
                    const wrapper = this.modalImageWrapper;
                    const centerX = wrapper.scrollLeft + wrapper.clientWidth / 2;
                    const centerY = wrapper.scrollTop + wrapper.clientHeight / 2;
                    
                    wrapper.scrollLeft = centerX * zoomRatio - wrapper.clientWidth / 2;
                    wrapper.scrollTop = centerY * zoomRatio - wrapper.clientHeight / 2;
                }
            } else {
                this.modalImage.classList.remove('zoomed');
                this.modalImageWrapper.style.cursor = 'default';
                this.modalImage.style.cursor = 'zoom-in';
            }
            
            if (this.modalZoomIn) {
                this.modalZoomIn.disabled = this.currentZoom >= this.maxZoom;
            }
            if (this.modalZoomOut) {
                this.modalZoomOut.disabled = this.currentZoom <= this.minZoom;
            }
        }

        _navigatePrev() {
            if (this.currentCarouselImages.length <= 1) return;
            
            this.currentImageIndex = (this.currentImageIndex - 1 + this.currentCarouselImages.length) % this.currentCarouselImages.length;
            this._loadCurrentImage();
        }

        _navigateNext() {
            if (this.currentCarouselImages.length <= 1) return;
            
            this.currentImageIndex = (this.currentImageIndex + 1) % this.currentCarouselImages.length;
            this._loadCurrentImage();
        }

        _loadCurrentImage() {
            const img = this.currentCarouselImages[this.currentImageIndex];
            if (!img || !this.modalImage) return;
            
            this._resetZoom();
            
            if (this.modalLoader) {
                this.modalLoader.hidden = false;
            }
            
            const imgSrc = img.src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande)\./g, '.').replace(/\?.*$/, '');
            const fullSrc = imgSrc.includes('?') ? imgSrc : `${imgSrc}?width=1500`;
            
            const hideLoader = () => {
                if (this.modalLoader) {
                    this.modalLoader.hidden = true;
                }
            };
            
            this.modalImage.onload = hideLoader;
            this.modalImage.onerror = hideLoader;
            this.modalImage.src = fullSrc;
            this.modalImage.alt = img.alt || '';
        }

        _startDrag(e) {
            if (this.currentZoom <= 1) return;
            
            e.preventDefault();
            
            this.mouseDown = true;
            this.dragStarted = false;
            this.startX = e.clientX;
            this.startY = e.clientY;
            this.scrollLeft = this.modalImageWrapper.scrollLeft;
            this.scrollTop = this.modalImageWrapper.scrollTop;
            
            this.modalImageWrapper.style.userSelect = 'none';
        }

        _drag(e) {
            if (this.currentZoom <= 1) return;
            if (!this.mouseDown) return;
            
            e.preventDefault();
            
            const dx = e.clientX - this.startX;
            const dy = e.clientY - this.startY;
            
            if (!this.dragStarted) {
                if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
                    this.dragStarted = true;
                    this.isDragging = true;
                    this.modalImageWrapper.style.cursor = 'grabbing';
                    this.modalImage.style.cursor = 'grabbing';
                    this.modalImageWrapper.style.scrollBehavior = 'auto';
                } else {
                    return;
                }
            }
            
            if (!this.isDragging) return;
            
            this.modalImageWrapper.scrollLeft = this.scrollLeft - dx;
            this.modalImageWrapper.scrollTop = this.scrollTop - dy;
        }

        _endDrag() {
            this.mouseDown = false;
            
            setTimeout(() => {
                this.dragStarted = false;
                this.isDragging = false;
            }, 10);
            
            if (this.modalImageWrapper) {
                this.modalImageWrapper.style.cursor = this.currentZoom > 1 ? 'grab' : 'default';
                this.modalImageWrapper.style.userSelect = '';
                this.modalImageWrapper.style.scrollBehavior = 'smooth';
            }
            if (this.modalImage) {
                this.modalImage.style.cursor = this.currentZoom > 1 ? 'zoom-out' : 'zoom-in';
            }
        }

        _startDragTouch(e) {
            if (this.currentZoom <= 1) return;
            
            e.preventDefault();
            
            const touch = e.touches[0];
            this.touchDown = true;
            this.dragStarted = false;
            this.startX = touch.clientX;
            this.startY = touch.clientY;
            this.scrollLeft = this.modalImageWrapper.scrollLeft;
            this.scrollTop = this.modalImageWrapper.scrollTop;
        }

        _dragTouch(e) {
            if (this.currentZoom <= 1) return;
            if (!this.touchDown) return;
            
            e.preventDefault();
            
            const touch = e.touches[0];
            const dx = touch.clientX - this.startX;
            const dy = touch.clientY - this.startY;
            
            if (!this.dragStarted) {
                if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
                    this.dragStarted = true;
                    this.isDragging = true;
                    this.modalImageWrapper.style.scrollBehavior = 'auto';
                } else {
                    return;
                }
            }
            
            if (!this.isDragging) return;
            
            this.modalImageWrapper.scrollLeft = this.scrollLeft - dx;
            this.modalImageWrapper.scrollTop = this.scrollTop - dy;
        }

        _endDragTouch() {
            this.touchDown = false;
            
            setTimeout(() => {
                this.dragStarted = false;
                this.isDragging = false;
            }, 10);
            
            if (this.modalImageWrapper) {
                this.modalImageWrapper.style.scrollBehavior = 'smooth';
            }
        }

        _setExpanded(body, btn, expanded) {
            const readMore = this.dataset.i18nReadMore || 'Read +';
            const readLess = this.dataset.i18nReadLess || 'Read -';
            if (expanded) {
                body.classList.add('madesa-depoimentos__text-body--expanded');
                btn.setAttribute('aria-expanded', 'true');
                btn.textContent = readLess;
            } else {
                body.classList.remove('madesa-depoimentos__text-body--expanded');
                btn.setAttribute('aria-expanded', 'false');
                btn.textContent = readMore;
            }
        }

        _needsToggle(body) {
            if (body.classList.contains('madesa-depoimentos__text-body--expanded')) {
                return true;
            }
            return body.scrollHeight > body.clientHeight + 1;
        }

        _syncToggleVisibility(body, btn) {
            if (!body || !btn) return;
            if (body.classList.contains('madesa-depoimentos__text-body--expanded')) {
                btn.hidden = false;
                return;
            }
            btn.hidden = !this._needsToggle(body);
        }

        _bindTextShells() {
            this._unbindTextShells();

            this.querySelectorAll('.madesa-depoimentos__text-shell').forEach((shell) => {
                const body = shell.querySelector('.madesa-depoimentos__text-body--clamp');
                const btn = shell.querySelector('[data-madesa-depoimentos-toggle]');
                if (!body || !btn) return;
                if (btn.dataset.madesaDepoimentosInit === '1') return;
                btn.dataset.madesaDepoimentosInit = '1';

                const ro = new ResizeObserver(() => {
                    this._syncToggleVisibility(body, btn);
                });
                ro.observe(body);

                const onClick = () => {
                    const expanded = body.classList.contains('madesa-depoimentos__text-body--expanded');
                    this._setExpanded(body, btn, !expanded);
                    this._syncToggleVisibility(body, btn);
                };
                btn.addEventListener('click', onClick);

                this._teardowns.push(() => {
                    ro.disconnect();
                    btn.removeEventListener('click', onClick);
                    delete btn.dataset.madesaDepoimentosInit;
                });

                requestAnimationFrame(() => {
                    this._syncToggleVisibility(body, btn);
                });
            });
        }

        _unbindTextShells() {
            if (this._teardowns && this._teardowns.length) {
                this._teardowns.forEach((fn) => fn());
                this._teardowns = [];
            }
        }
    }

    customElements.define('madesa-depoimentos', MadesaDepoimentos);
}

if (!customElements.get('madesa-banner-media-texto')) {
    class MadesaBannerMediaTexto extends HTMLElement {
        constructor() {
            super();
            this._onPlayClick = this._onPlayClick.bind(this);
        }

        connectedCallback() {
            const playBtn = this.querySelector('.madesa-banner-media-texto__play-fab');
            if (!playBtn) return;

            playBtn.removeEventListener('click', this._onPlayClick);
            playBtn.addEventListener('click', this._onPlayClick);
        }

        disconnectedCallback() {
            const playBtn = this.querySelector('.madesa-banner-media-texto__play-fab');
            if (playBtn) {
                playBtn.removeEventListener('click', this._onPlayClick);
            }
        }

        _onPlayClick(e) {
            e.preventDefault();

            const hosted = this.querySelector('video.madesa-banner-media-texto__hosted-video');
            if (hosted) {
                hosted.controls = true;
                this.setAttribute('data-video-playing', 'true');
                const p = hosted.play();
                if (p && typeof p.catch === 'function') {
                    p.catch(function () {});
                }
                return;
            }

            const iframe = this.querySelector('.madesa-banner-media-texto__iframe');
            if (!iframe) return;

            const embed = iframe.getAttribute('data-embed');
            if (!embed) return;

            iframe.src = embed;
            this.setAttribute('data-video-playing', 'true');
        }
    }

    customElements.define('madesa-banner-media-texto', MadesaBannerMediaTexto);
}

if (!customElements.get('madesa-media-carrossel')) {
    class MadesaMediaCarrossel extends HTMLElement {
        constructor() {
            super();
            this.carousel = null;
        }

        connectedCallback() {
            if (this.dataset.initialized === '1') return;

            const showPagination = this.dataset.showPagination !== 'false';

            this.carousel = new Carousel(this, {
                infinite: true,
                center: true,
                slidesPerPage: 1,
                transition: false,
                friction: 0.28,
                Dots: showPagination,
                Navigation: {
                    prevTpl: '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 11L1.5 6L6.5 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                    nextTpl: '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L6.5 6L1.5 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                },
                Panzoom: {
                    bounce: false,
                    rubberband: false,
                    dragFriction: 0.65,
                    friction: 0.55,
                    decelFriction: 0.55,
                    maxVelocity: 28,
                },
            });

            this.dataset.initialized = '1';
        }

        disconnectedCallback() {
            if (this.carousel && typeof this.carousel.destroy === 'function') {
                this.carousel.destroy();
            }

            this.carousel = null;
            delete this.dataset.initialized;
        }
    }

    customElements.define('madesa-media-carrossel', MadesaMediaCarrossel);
}

// PÁGINA DE PROVA SOCIAL
const initMadesaCozinhaDrag = (container = document) => {
    const sections = container.querySelectorAll('.madesa-cozinha');

    sections.forEach((section) => {
        if (section.dataset.desktopDragReady === 'true') return;

        const scroller = section.querySelector('slideshow-slides[ref="scroller"]');
        if (!scroller) return;

        section.dataset.desktopDragReady = 'true';

        let isPointerDown = false;
        let isDragging = false;
        let startX = 0;
        let startScrollLeft = 0;
        let suppressClickUntil = 0;
        const dragThreshold = 6;

        const hasOverflow = () => scroller.scrollWidth - scroller.clientWidth > 2;

        scroller.addEventListener('pointerdown', (event) => {
            if (event.pointerType !== 'mouse' || event.button !== 0) return;

            if (!window.matchMedia('(min-width: 1024px)').matches) return;
            if (!hasOverflow()) return;

            if (!(event.target instanceof Element)) return;

            const targetSlide = event.target.closest('slideshow-slide');
            if (!targetSlide) return;
            if (targetSlide.querySelector('a[href]')) return;

            isPointerDown = true;
            isDragging = false;
            startX = event.clientX;
            startScrollLeft = scroller.scrollLeft;
            section.classList.add('madesa-cozinha--drag-ready');

            try {
                scroller.setPointerCapture(event.pointerId);
            } catch (e) {}
        });

        scroller.addEventListener('pointermove', (event) => {
            if (!isPointerDown || event.pointerType !== 'mouse') return;

            const deltaX = event.clientX - startX;

            if (!isDragging && Math.abs(deltaX) > dragThreshold) {
                isDragging = true;
                section.classList.add('madesa-cozinha--dragging');
            }

            if (!isDragging) return;

            event.preventDefault();
            scroller.scrollLeft = startScrollLeft - deltaX;
        });

        const finishDrag = (event) => {
            if (!isPointerDown) return;

            isPointerDown = false;
            section.classList.remove('madesa-cozinha--drag-ready');

            if (isDragging) {
                suppressClickUntil = performance.now() + 300;
            }

            isDragging = false;
            section.classList.remove('madesa-cozinha--dragging');

            if (event && 'pointerId' in event) {
                try {
                    scroller.releasePointerCapture(event.pointerId);
                } catch (e) {}
            }
        };

        scroller.addEventListener('pointerup', finishDrag);
        scroller.addEventListener('pointercancel', finishDrag);
        scroller.addEventListener('lostpointercapture', finishDrag);

        scroller.addEventListener('click', (event) => {
            if (performance.now() < suppressClickUntil) {
                event.preventDefault();
                event.stopPropagation();
            }
        }, true);
    });
};

initMadesaCozinhaDrag();
document.addEventListener('shopify:section:load', (event) => initMadesaCozinhaDrag(event.target));

if (!customElements.get('prova-social-filter')) {
    class ProvaSocialFilter extends HTMLElement {
        constructor() {
            super();

            this.allowMultipleColors = this.dataset.allowMultipleColors === 'true';
            this.allowMultipleLines = this.dataset.allowMultipleLines === 'true';
            this.enableZoomControls = this.dataset.enableZoomControls === 'true';
            this.emptyMessage = this.dataset.emptyMessage || '';
            
            this.currentCores = [];
            
            this.colorButtons = this.querySelectorAll('.prova-social__color-btn');
            this.lineButtons = this.querySelectorAll('.prova-social__line-btn');
            this.carouselGroups = this.querySelectorAll('.prova-social__carousel-group');
            this.carouselsContainer = this.querySelector('[data-carousels-container]');
            this.colorFilterGroup = this.querySelector('.prova-social__color-filters').closest('.prova-social__filter-group');
            
            const defaultLinha = this.dataset.defaultLinha || 'vik';
            const defaultLinhaExists = Array.from(this.lineButtons).some(btn => btn.dataset.linha === defaultLinha);
            
            if (defaultLinhaExists) {
                this.currentLinhas = [defaultLinha];
            } else if (this.lineButtons.length > 0) {
                this.currentLinhas = [this.lineButtons[0].dataset.linha];
            } else {
                this.currentLinhas = [];
            }
            
            this.modal = document.getElementById('prova-social-modal');
            this.modalImage = this.modal?.querySelector('.prova-social__modal-image');
            this.modalImageWrapper = this.modal?.querySelector('.prova-social__modal-image-wrapper');
            this.modalLoader = this.modal?.querySelector('.prova-social__modal-loader');
            this.modalClose = this.modal?.querySelector('.prova-social__modal-close');
            this.modalOverlay = this.modal?.querySelector('.prova-social__modal-overlay');
            this.modalZoomControls = this.modal?.querySelector('.prova-social__modal-zoom-controls');
            this.modalZoomIn = this.modal?.querySelector('.prova-social__modal-zoom-in');
            this.modalZoomOut = this.modal?.querySelector('.prova-social__modal-zoom-out');
            this.modalZoomReset = this.modal?.querySelector('.prova-social__modal-zoom-reset');
            this.modalNavPrev = this.modal?.querySelector('.prova-social__modal-nav-prev');
            this.modalNavNext = this.modal?.querySelector('.prova-social__modal-nav-next');
            
            this.currentZoom = 1;
            this.minZoom = 1;
            this.maxZoom = 3;
            this.zoomStep = 0.5;
            this.currentImageIndex = 0;
            this.currentCarouselImages = [];
            this.isDragging = false;
            this.dragStarted = false;
            this.mouseDown = false;
            this.touchDown = false;
            this.startX = 0;
            this.startY = 0;
            this.scrollLeft = 0;
            this.scrollTop = 0;
        }

        connectedCallback() {
            this.setupEventListeners();
            this.applyStateFromUrl();
            this.updateLineButtonsState();
            this.updateColorFiltersVisibility();
            this.filterCarousels();
            this.initializeVisibleCarousels();
        }

        disconnectedCallback() {
            this.destroyAllCarousels();
        }

        // Lê ?linha= e ?cor= da URL e ajusta o estado inicial dos filtros.
        // Valida contra os carrosséis realmente existentes no DOM: combinação
        // inválida (ex.: linha=nice&cor=preta) descarta a cor e cai em "todas".
        applyStateFromUrl() {
            let params;
            try {
                params = new URLSearchParams(window.location.search);
            } catch (e) {
                return;
            }

            const linhaParam = params.get('linha');
            const corParam = params.get('cor');

            if (linhaParam) {
                const requested = linhaParam.split(',').map(v => v.trim().toLowerCase()).filter(Boolean);
                const validLinhas = requested.filter(l =>
                    Array.from(this.lineButtons).some(btn => btn.dataset.linha === l)
                );
                if (validLinhas.length) {
                    this.currentLinhas = this.allowMultipleLines ? validLinhas : [validLinhas[0]];
                }
            }

            if (corParam && corParam.trim().toLowerCase() !== 'todas') {
                const requested = corParam.split(',').map(v => v.trim().toLowerCase()).filter(Boolean);
                const validCores = requested.filter(cor =>
                    Array.from(this.carouselGroups).some(group =>
                        group.dataset.cor === cor && this.currentLinhas.includes(group.dataset.linha)
                    )
                );
                if (validCores.length) {
                    this.currentCores = this.allowMultipleColors ? validCores : [validCores[0]];
                }
            }
        }

        // Reflete o estado atual (linha + cor) na URL, sem recarregar a página.
        // Usa replaceState para não poluir o histórico do navegador.
        syncUrl() {
            if (window.Shopify && window.Shopify.designMode) return; // não mexe na URL dentro do editor de tema

            let params;
            try {
                params = new URLSearchParams(window.location.search);
            } catch (e) {
                return;
            }

            if (this.currentLinhas.length) {
                params.set('linha', this.currentLinhas.join(','));
            } else {
                params.delete('linha');
            }

            if (this.currentCores.length) {
                params.set('cor', this.currentCores.join(','));
            } else {
                params.delete('cor');
            }

            const query = params.toString();
            const newUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
            window.history.replaceState(null, '', newUrl);
        }

        setupEventListeners() {
            this.addEventListener('click', this.handleClick.bind(this));
            
            if (this.modalClose) {
                this.modalClose.addEventListener('click', () => this.closeModal());
            }
            if (this.modalOverlay) {
                this.modalOverlay.addEventListener('click', () => this.closeModal());
            }
            
            if (this.enableZoomControls) {
                if (this.modalZoomIn) {
                    this.modalZoomIn.addEventListener('click', () => this.zoomIn());
                }
                if (this.modalZoomOut) {
                    this.modalZoomOut.addEventListener('click', () => this.zoomOut());
                }
                if (this.modalZoomReset) {
                    this.modalZoomReset.addEventListener('click', () => this.resetZoom());
                }
                if (this.modalNavPrev) {
                    this.modalNavPrev.addEventListener('click', () => this.navigatePrev());
                }
                if (this.modalNavNext) {
                    this.modalNavNext.addEventListener('click', () => this.navigateNext());
                }
                
                if (this.modalImage) {
                    this.modalImage.addEventListener('click', (e) => {
                        if (this.dragStarted) return;
                        
                        this.toggleZoom();
                    });
                }
                
                if (this.modalImageWrapper) {
                    this.modalImageWrapper.addEventListener('mousedown', this.startDrag.bind(this));
                    this.modalImageWrapper.addEventListener('mousemove', this.drag.bind(this));
                    this.modalImageWrapper.addEventListener('mouseup', this.endDrag.bind(this));
                    this.modalImageWrapper.addEventListener('mouseleave', this.endDrag.bind(this));
                    
                    this.modalImageWrapper.addEventListener('touchstart', this.startDragTouch.bind(this), { passive: false });
                    this.modalImageWrapper.addEventListener('touchmove', this.dragTouch.bind(this), { passive: false });
                    this.modalImageWrapper.addEventListener('touchend', this.endDragTouch.bind(this));
                    this.modalImageWrapper.addEventListener('touchcancel', this.endDragTouch.bind(this));
                }
            } else {
                if (this.modalImage) {
                    this.modalImage.addEventListener('click', () => this.closeModal());
                }
            }
            
            document.addEventListener('keydown', (e) => {
                if (this.modal && !this.modal.hidden) {
                    if (e.key === 'Escape') {
                        this.closeModal();
                    } else if (this.enableZoomControls) {
                        if (e.key === 'ArrowLeft') {
                            this.navigatePrev();
                        } else if (e.key === 'ArrowRight') {
                            this.navigateNext();
                        } else if (e.key === '+' || e.key === '=') {
                            this.zoomIn();
                        } else if (e.key === '-' || e.key === '_') {
                            this.zoomOut();
                        } else if (e.key === '0') {
                            this.resetZoom();
                        }
                    }
                }
            });
        }

        handleClick(e) {
            const lineBtn = e.target.closest('.prova-social__line-btn');
            const colorBtn = e.target.closest('.prova-social__color-btn');
            const carouselImage = e.target.closest('.prova-social__image-wrapper img');

            if (lineBtn) {
                this.handleLineClick(lineBtn);
            } else if (colorBtn) {
                this.handleColorClick(colorBtn);
            } else if (carouselImage) {
                this.openModal(carouselImage);
            }
        }

        openModal(img) {
            if (!this.modal || !this.modalImage) return;
            
            this.currentZoom = 1;
            this.resetZoom();
            
            const carouselGroup = img.closest('.prova-social__carousel-group');
            if (carouselGroup && this.enableZoomControls) {
                this.currentCarouselImages = Array.from(carouselGroup.querySelectorAll('.prova-social__image-wrapper img'));
                this.currentImageIndex = this.currentCarouselImages.indexOf(img);
                
                if (this.modalNavPrev) {
                    this.modalNavPrev.hidden = this.currentCarouselImages.length <= 1;
                }
                if (this.modalNavNext) {
                    this.modalNavNext.hidden = this.currentCarouselImages.length <= 1;
                }
            }
            
            if (this.modalLoader) {
                this.modalLoader.hidden = false;
            }
            
            const imgSrc = img.src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande)\./g, '.').replace(/\?.*$/, '');
            const fullSrc = imgSrc.includes('?') ? imgSrc : `${imgSrc}?width=1500`;
            
            const cachedImage = this.getFromCache(fullSrc);
            
            const hideLoader = () => {
                if (this.modalLoader) {
                    this.modalLoader.hidden = true;
                }
            };
            
            this.modalImage.onload = hideLoader;
            this.modalImage.onerror = hideLoader;
            
            if (cachedImage) {
                this.modalImage.src = cachedImage;
            } else {
                this.modalImage.src = fullSrc;
            }
            
            this.modalImage.alt = img.alt || '';
            
            if (this.modalImageWrapper) {
                this.modalImageWrapper.style.cursor = 'default';
            }
            if (this.modalImage) {
                this.modalImage.style.cursor = 'zoom-in';
            }
            
            if (this.modalZoomControls) {
                this.modalZoomControls.hidden = !this.enableZoomControls;
            }
            
            this.modal.hidden = false;
            document.body.style.overflow = 'hidden';
        }

        closeModal() {
            if (!this.modal) return;
            
            if (this.modalImage && this.modalImage.src) {
                this.addToCache(this.modalImage.src);
            }
            
            this.modal.hidden = true;
            document.body.style.overflow = '';
            this.resetZoom();
            this.currentCarouselImages = [];
            this.currentImageIndex = 0;
            
            if (this.modalImage) {
                this.modalImage.src = '';
                this.modalImage.alt = '';
            }
        }

        zoomIn() {
            if (this.currentZoom >= this.maxZoom) return;
            this.currentZoom = Math.min(this.currentZoom + this.zoomStep, this.maxZoom);
            this.applyZoom();
        }

        zoomOut() {
            if (this.currentZoom <= this.minZoom) return;
            this.currentZoom = Math.max(this.currentZoom - this.zoomStep, this.minZoom);
            this.applyZoom();
        }

        resetZoom() {
            this.currentZoom = this.minZoom;
            this.applyZoom();
            if (this.modalImageWrapper) {
                this.modalImageWrapper.scrollLeft = 0;
                this.modalImageWrapper.scrollTop = 0;
            }
        }

        toggleZoom() {
            if (this.currentZoom > this.minZoom) {
                this.resetZoom();
            } else {
                this.currentZoom = 2;
                this.applyZoom();
            }
        }

        applyZoom() {
            if (!this.modalImage || !this.modalImageWrapper) return;
            
            this.modalImage.style.transform = `scale(${this.currentZoom})`;
            
            if (this.currentZoom > 1) {
                this.modalImage.classList.add('zoomed');
                this.modalImageWrapper.style.cursor = 'grab';
                this.modalImage.style.cursor = 'zoom-out';
            } else {
                this.modalImage.classList.remove('zoomed');
                this.modalImageWrapper.style.cursor = 'default';
                this.modalImage.style.cursor = 'zoom-in';
            }
            
            if (this.modalZoomIn) {
                this.modalZoomIn.disabled = this.currentZoom >= this.maxZoom;
            }
            if (this.modalZoomOut) {
                this.modalZoomOut.disabled = this.currentZoom <= this.minZoom;
            }
        }

        navigatePrev() {
            if (this.currentCarouselImages.length <= 1) return;
            
            this.currentImageIndex = (this.currentImageIndex - 1 + this.currentCarouselImages.length) % this.currentCarouselImages.length;
            this.loadCurrentImage();
        }

        navigateNext() {
            if (this.currentCarouselImages.length <= 1) return;
            
            this.currentImageIndex = (this.currentImageIndex + 1) % this.currentCarouselImages.length;
            this.loadCurrentImage();
        }

        loadCurrentImage() {
            const img = this.currentCarouselImages[this.currentImageIndex];
            if (!img || !this.modalImage) return;
            
            this.resetZoom();
            
            if (this.modalLoader) {
                this.modalLoader.hidden = false;
            }
            
            const imgSrc = img.src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande)\./g, '.').replace(/\?.*$/, '');
            const fullSrc = imgSrc.includes('?') ? imgSrc : `${imgSrc}?width=1500`;
            
            const hideLoader = () => {
                if (this.modalLoader) {
                    this.modalLoader.hidden = true;
                }
            };
            
            this.modalImage.onload = hideLoader;
            this.modalImage.onerror = hideLoader;
            
            const cachedImage = this.getFromCache(fullSrc);
            
            if (cachedImage) {
                this.modalImage.src = cachedImage;
            } else {
                this.modalImage.src = fullSrc;
            }
            
            this.modalImage.alt = img.alt || '';
        }

        startDrag(e) {
            if (this.currentZoom <= 1) return;
            
            e.preventDefault();
            
            this.mouseDown = true;
            this.dragStarted = false;
            this.startX = e.clientX;
            this.startY = e.clientY;
            this.scrollLeft = this.modalImageWrapper.scrollLeft;
            this.scrollTop = this.modalImageWrapper.scrollTop;
            
            this.modalImageWrapper.style.userSelect = 'none';
        }

        drag(e) {
            if (this.currentZoom <= 1) return;
            if (!this.mouseDown) return;
            
            e.preventDefault();
            
            const dx = e.clientX - this.startX;
            const dy = e.clientY - this.startY;
            
            if (!this.dragStarted) {
                if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
                    this.dragStarted = true;
                    this.isDragging = true;
                    this.modalImageWrapper.style.cursor = 'grabbing';
                    this.modalImage.style.cursor = 'grabbing';
                    this.modalImageWrapper.style.scrollBehavior = 'auto';
                } else {
                    return;
                }
            }
            
            if (!this.isDragging) return;
            
            this.modalImageWrapper.scrollLeft = this.scrollLeft - dx;
            this.modalImageWrapper.scrollTop = this.scrollTop - dy;
        }

        endDrag() {
            this.mouseDown = false;
            
            setTimeout(() => {
                this.dragStarted = false;
                this.isDragging = false;
            }, 10);
            
            if (this.modalImageWrapper) {
                this.modalImageWrapper.style.cursor = this.currentZoom > 1 ? 'grab' : 'default';
                this.modalImageWrapper.style.userSelect = '';
                this.modalImageWrapper.style.scrollBehavior = 'smooth';
            }
            if (this.modalImage) {
                this.modalImage.style.cursor = this.currentZoom > 1 ? 'zoom-out' : 'zoom-in';
            }
        }

        startDragTouch(e) {
            if (this.currentZoom <= 1) return;
            
            e.preventDefault();
            
            const touch = e.touches[0];
            this.touchDown = true;
            this.dragStarted = false;
            this.startX = touch.clientX;
            this.startY = touch.clientY;
            this.scrollLeft = this.modalImageWrapper.scrollLeft;
            this.scrollTop = this.modalImageWrapper.scrollTop;
        }

        dragTouch(e) {
            if (this.currentZoom <= 1) return;
            if (!this.touchDown) return;
            
            e.preventDefault();
            
            const touch = e.touches[0];
            const dx = touch.clientX - this.startX;
            const dy = touch.clientY - this.startY;
            
            if (!this.dragStarted) {
                if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
                    this.dragStarted = true;
                    this.isDragging = true;
                    this.modalImageWrapper.style.scrollBehavior = 'auto';
                } else {
                    return;
                }
            }
            
            if (!this.isDragging) return;
            
            this.modalImageWrapper.scrollLeft = this.scrollLeft - dx;
            this.modalImageWrapper.scrollTop = this.scrollTop - dy;
        }

        endDragTouch() {
            this.touchDown = false;
            
            setTimeout(() => {
                this.dragStarted = false;
                this.isDragging = false;
            }, 10);
            
            if (this.modalImageWrapper) {
                this.modalImageWrapper.style.scrollBehavior = 'smooth';
            }
        }

        getFromCache(imageUrl) {
            try {
                const cacheKey = 'prova_social_image_cache';
                const cacheData = localStorage.getItem(cacheKey);
                
                if (!cacheData) return null;
                
                const cache = JSON.parse(cacheData);
                const cachedItem = cache.find(item => item.url === imageUrl);
                
                if (cachedItem) {
                    cachedItem.lastAccessed = Date.now();
                    localStorage.setItem(cacheKey, JSON.stringify(cache));
                    return cachedItem.url;
                }
                
                return null;
            } catch (e) {
                console.error('Erro ao ler cache:', e);
                return null;
            }
        }

        addToCache(imageUrl) {
            try {
                const cacheKey = 'prova_social_image_cache';
                const maxCacheSize = 2;
                let cache = [];
                
                const cacheData = localStorage.getItem(cacheKey);
                if (cacheData) {
                    cache = JSON.parse(cacheData);
                }
                
                const existingIndex = cache.findIndex(item => item.url === imageUrl);
                
                if (existingIndex !== -1) {
                    cache[existingIndex].lastAccessed = Date.now();
                } else {
                    cache.push({
                        url: imageUrl,
                        lastAccessed: Date.now()
                    });
                    
                    if (cache.length > maxCacheSize) {
                        cache.sort((a, b) => b.lastAccessed - a.lastAccessed);
                        cache = cache.slice(0, maxCacheSize);
                    }
                }
                
                localStorage.setItem(cacheKey, JSON.stringify(cache));
            } catch (e) {
                console.error('Erro ao salvar cache:', e);
            }
        }

        handleLineClick(btn) {
            const linha = btn.dataset.linha;
            
            if (this.allowMultipleLines) {
                if (this.currentLinhas.includes(linha)) {
                    this.currentLinhas = this.currentLinhas.filter(l => l !== linha);
                    
                    if (this.currentLinhas.length === 0) {
                        this.currentLinhas = [this.lineButtons[0].dataset.linha];
                    }
                } else {        
                    this.currentLinhas.push(linha);
                }
                
            } else {
                if (this.currentLinhas.length === 1 && this.currentLinhas[0] === linha) return;
                
                this.currentLinhas = [linha];
            }
            
            this.updateLineButtonsState();
            
            this.currentCores = [];

            this.updateColorFiltersVisibility();
            this.destroyAllCarousels();
            this.filterCarousels();
            this.initializeVisibleCarousels();
            this.syncUrl();
        }

        handleColorClick(btn) {
            const cor = btn.dataset.cor;
            
            if (this.allowMultipleColors) {
                if (cor === '') {
                    this.currentCores = [];
                } else {
                    const index = this.currentCores.indexOf(cor);
                    if (index > -1) {
                        this.currentCores.splice(index, 1);
                    } else {
                        this.currentCores.push(cor);
                    }
                }
                
                for (const b of this.colorButtons) {
                    if (b.dataset.cor === '') {
                        b.classList.toggle('active', this.currentCores.length === 0);
                    } else {
                        b.classList.toggle('active', this.currentCores.includes(b.dataset.cor));
                    }
                }
            } else {
                const isSameCor = this.currentCores.length === 1 && this.currentCores[0] === cor;
                
                if (isSameCor && cor !== '') {
                    this.currentCores = [];
                } else {
                    this.currentCores = cor === '' ? [] : [cor];
                }
                
                for (const b of this.colorButtons) {
                    if (b.dataset.cor === '') {
                        b.classList.toggle('active', this.currentCores.length === 0);
                    } else {
                        b.classList.toggle('active', this.currentCores.includes(b.dataset.cor));
                    }
                }
            }

            this.filterCarousels();
            this.initializeVisibleCarousels();
            this.syncUrl();
        }

        updateLineButtonsState() {
            for (const btn of this.lineButtons) {
                btn.classList.toggle('active', this.currentLinhas.includes(btn.dataset.linha));
            }
        }

        updateColorFiltersVisibility() {
            let hasVisibleColors = false;

            for (const btn of this.colorButtons) {
                const cor = btn.dataset.cor;
                
                if (cor === '' && !btn.dataset.linha) {
                    btn.hidden = false;
                    btn.classList.toggle('active', this.currentCores.length === 0);
                    hasVisibleColors = true;
                } else {
                    const hasCarouselWithColor = Array.from(this.carouselGroups).some(group => 
                        group.dataset.cor === cor && this.currentLinhas.includes(group.dataset.linha)
                    );
                    
                    btn.hidden = !hasCarouselWithColor;
                    
                    if (hasCarouselWithColor) {
                        hasVisibleColors = true;
                        btn.classList.toggle('active', this.currentCores.includes(cor));
                    } else {
                        btn.classList.remove('active');
                    }
                }
            }

            if (this.colorFilterGroup) {
                this.colorFilterGroup.hidden = !hasVisibleColors;
            }
        }

        filterCarousels() {
            let visibleCount = 0;
            
            for (const group of this.carouselGroups) {
                const isCorrectLinha = this.currentLinhas.includes(group.dataset.linha);
                const isCorrectCor = this.currentCores.length === 0 || this.currentCores.includes(group.dataset.cor);
                const isVisible = isCorrectLinha && isCorrectCor;
                
                group.hidden = !isVisible;
                if (isVisible) visibleCount++;
            }

            const infoBlocks = this.querySelectorAll('.prova-social__info');
            for (const info of infoBlocks) {
                info.hidden = !this.currentLinhas.includes(info.dataset.linha);
            }

            this.toggleEmptyState(visibleCount === 0);
        }

        toggleEmptyState(show) {
            let emptyState = this.querySelector('.prova-social__empty');
            
            if (show && !emptyState) {
                emptyState = document.createElement('div');
                emptyState.className = 'prova-social__empty';
                const message = document.createElement('p');
                message.textContent = this.emptyMessage;
                emptyState.appendChild(message);
                this.carouselsContainer.appendChild(emptyState);
            } else if (!show && emptyState) {
                emptyState.remove();
            }
        }

        initializeVisibleCarousels() {
            requestAnimationFrame(() => {
                for (const group of this.carouselGroups) {
                    if (group.hidden) continue;
                    const carouselEl = group.querySelector('card-slider[data-defer-init]');
                    if (carouselEl?.initCarousel) {
                        try {
                            carouselEl.initCarousel();
                        } catch (error) {
                            console.error('Carousel init error:', error);
                        }
                    }
                }
            });
        }

        destroyAllCarousels() {
            for (const el of this.querySelectorAll('card-slider[data-defer-init]')) {
                el.destroyCarousel?.();
            }
        }
    }

    customElements.define('prova-social-filter', ProvaSocialFilter);
}